import { ACHProcessorData } from "globalConstants/application";

export const ACHProcessorBoardingFields = {
	ACHProcessor: ACHProcessorData.ACHProcessor,
	AchBoardingStatus: {
		name: "achBoardingStatus",
		displayName: "ACH Boarding Status",
		beName: "ach_boarding_status",
	},
	StraddleIdentifier: {
		name: "straddleIdentifier",
		displayName: "Straddle Identifier",
		beName: "straddle_identifier",
	},
	StraddleGateId: {
		name: "straddleGateId",
		displayName: "Straddle Gate ID",
		beName: "gate_id",
	},
	StraddleGateKeyId: {
		name: "straddleGateKeyId",
		displayName: "Straddle Gate Key ID",
		beName: "gate_key_id",
	},
	StraddleAccountStatus: {
		name: "straddleAccountStatus",
		displayName: "Straddle Account Status",
		beName: "straddle_account_status",
	},
	CustomerType: ACHProcessorData.CustomerType,
	PaymentAuthorizationType: ACHProcessorData.PaymentAuthorizationType,
	StatementDescriptor: ACHProcessorData.StatementDescriptor,
	UseOfPaymentServiceDescription:
		ACHProcessorData.UseOfPaymentServiceDescription,
	BillingRouting: ACHProcessorData.BillingRouting,
	BillingAccount: ACHProcessorData.BillingAccount,
	BillingBank: ACHProcessorData.BillingBank,
	BillingAccountName: ACHProcessorData.BillingAccountName,
	MonthlyVolumeAch: {
		name: ACHProcessorData.MonthlyVolumeAch.name,
		displayName: "Monthly Volume",
		beName: ACHProcessorData.MonthlyVolumeAch.beName,
	},
	TicketCountAch: {
		name: ACHProcessorData.TicketCountAch.name,
		displayName: "Ticket Count",
		beName: ACHProcessorData.TicketCountAch.beName,
	},
	HighTicketAch: {
		name: ACHProcessorData.HighTicketAch.name,
		displayName: "High Ticket",
		beName: ACHProcessorData.HighTicketAch.beName,
	},
	MonthlyVolumeAchPayouts: {
		name: ACHProcessorData.MonthlyVolumeAchPayouts.name,
		displayName: "Monthly Volume",
		beName: ACHProcessorData.MonthlyVolumeAchPayouts.beName,
	},
	TicketCountAchPayouts: {
		name: ACHProcessorData.TicketCountAchPayouts.name,
		displayName: "Ticket Count",
		beName: ACHProcessorData.TicketCountAchPayouts.beName,
	},
	HighTicketAchPayouts: {
		name: ACHProcessorData.HighTicketAchPayouts.name,
		displayName: "High Ticket",
		beName: ACHProcessorData.HighTicketAchPayouts.beName,
	},
	ACHLabel: {
		name: "achLabel",
		displayName: "ACH",
		beName: "achLabel",
	},
	ACHPayoutsLabel: {
		name: "achPayoutsLabel",
		displayName: "ACH Payouts",
		beName: "achPayoutsLabel",
	},
};
